import { resolve, define } from 'acast-www-utils';

export default {
  get(key, defaultValue = null) {
    return resolve(window['acast/config'], key, defaultValue);
  },

  set(key, value) {
    return define(window['acast/config'], key, value);
  },
};
